<!-- 医院信息管理 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
                        :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                        @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <!-- 主要信息 -->
                            <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                                <el-form label-width="110px" id="mainInfo" class="baseForm" :show-message="false"
                                    :model="sendDataInfo" ref="sendDataInfo" size="mini">
                                    <el-row v-if="dataActionBox.actionType != 2">
                                        <el-form-item :label="formOneValue.showField"
                                            v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                            :key="formOneKey" v-if="formOneValue.isShow == 1"
                                            :prop="formOneValue.entityField"
                                            :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <el-input v-if="formOneValue.fieldType == 'search'"
                                                :disabled="formOneValue.isChange == 0" clearable
                                                v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.setField, formOneValue.entityField, formOneValue.isIndex)">
                                                <el-button
                                                    @click="openSearch(formOneValue.searchId, formOneValue.setField, formOneValue.entityField, formOneValue.isIndex)"
                                                    slot="append" icon="el-icon-search"></el-button>
                                            </el-input>
                                            <df-date :isdisabled="formOneValue.isChange == 0"
                                                v-else-if="formOneValue.fieldType == 'date'"
                                                :isShowLong="formOneValue.entityField == 'glTervalidity' ? true : false"
                                                @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                            <div
                                                v-else-if="formOneValue.entityField == 'fileList' || formOneValue.entityField == 'businesslicense'">
                                                <input style="display: none;" type="file" :id="formOneValue.entityField"
                                                    multiple :name="formOneValue.entityField"
                                                    @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e, formOneValue.entityField) }" />
                                                <ul v-if="sendDataInfo[formOneValue.entityField]" class="upload">
                                                    <li v-for="(val, key) in sendDataInfo[formOneValue.entityField]"
                                                        :key="key">
                                                        <i class="el-icon-error del"
                                                            @click="delRemove(key, formOneValue.entityField)"></i>
                                                        <cusImage style="width: 40px; height: 40px;"
                                                            :src="`${imgUrl}/${val.fileUrl}`"
                                                            :preview-src-list="[`${imgUrl}/${val.fileUrl}`]">
                                                        </cusImage>
                                                    </li>
                                                    <li>
                                                        <label :for="formOneValue.entityField" class="image_label">
                                                            <i class="el-icon-plus icon"></i>
                                                        </label>
                                                    </li>
                                                </ul>
                                                <ul v-else class="upload">
                                                    <li>
                                                        <label :for="formOneValue.entityField" class="image_label">
                                                            <i class="el-icon-plus icon"></i>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div id="manrange" v-else-if="formOneValue.entityField == 'manrange'">
                                                <div class="cmContent">
                                                    <el-button v-if="dataActionBox.actionType < 2" class="cmButton"
                                                        @click="openRange(formOneValue.showField, 'manrange')" type="info" plain
                                                        size="mini">选择{{ formOneValue.showField }}</el-button>
                                                    <el-input type="textarea" v-model="sendDataInfo.manrangeName"
                                                        readonly>
                                                    </el-input>
                                                </div>
                                            </div>
                                            <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                :maxlength="$store.state.inputLength"
                                                @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)"
                                                :disabled="formOneValue.isChange == 0" clearable></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row v-if="dataActionBox.actionType == 2">
                                        <el-form-item :label="formOneValue.showField + ':'"
                                            v-if="formOneValue.isShow == 1"
                                            v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                            :key="formOneKey">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                            <span v-if="formOneValue.isRift == 1">
                                                <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                    sendDataInfo[formOneValue.entityField] }}</a>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'date'">
                                                <span v-if="sendDataInfo[formOneValue.entityField]">
                                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                </span>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                {{ $common.getIsGsp(formOneValue.formatterContent,sendDataInfo[formOneValue.entityField])}}
                                            </span>
                                            <ul v-else-if="formOneValue.entityField == 'fileList' || formOneValue.entityField == 'businesslicense'"
                                                class="upload">
                                                <li v-for="(val, key) in sendDataInfo[formOneValue.entityField]"
                                                    :key="key">
                                                    <cusImage style="width: 40px; height: 40px;"
                                                        :src="`${imgUrl}/${val.fileUrl}`"
                                                        :preview-src-list="[`${imgUrl}/${val.fileUrl}`]">
                                                    </cusImage>
                                                </li>
                                            </ul>
                                            <div id="manrange" v-else-if="formOneValue.entityField == 'manrange'">
                                                <div class="cmContent">
                                                    <el-input type="textarea" v-model="sendDataInfo.manrangeName"
                                                        readonly>
                                                    </el-input>
                                                </div>
                                            </div>
                                            <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <!-- 页脚 -->
                <div class="foot">
                    <div>
                        <!-- <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                            @click="showPrintPlan">打印
                        </el-button> -->
                        <el-button @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">保存</el-button>
                    </div>
                    <div v-if="footForm">
                        <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                            <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                                <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel"
                :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 范围穿梭框 -->
        <el-dialog :title="'选择' + rangeTitle" :visible.sync="dialogRange" width="70%" :modal-append-to-body='true'
            id="csDia" :append-to-body="true" :before-close="handleClose">
            <div class="edit_dev">
                <el-transfer filterable v-if="dialogRange" target-order="push" :filter-method="filterMethod"
                    filter-placeholder="请输入范围名称" v-model="rangeValue" :titles="['未选择', '已选择']" :data="transferData">
                </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="confirmRange">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "basemanufacturerAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            imgUrl: window.global_config.BASE_IMG_URL,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            showTabs: "",
            formDataList: [],
            selectedDetailsIndex: 0, //选择索引
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: [],
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            parentSearchData: {},
            seIndex: 0,
            fField: "",
            seType: "",
            seId: "",
            setField: "",
            inputel: [],
            //---------经营范围
            manrangeList: [],
            rangeValue: [],
            transferData: [],
            rangeTitle: "",
            dialogRange: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.manufacturer": {
            handler: function (newValue, oldVal) {
                this.sendDataInfo.manufacturerMne = this.$common.createPinyinCode(newValue, this.sendDataInfo.manufacturerMne);
            },
            deep: true
        }
    },
    //方法集合
    methods: {
        //-------------选择经营范围
        // 是否确认关闭
        handleClose(done) {
            this.$confirm("关闭弹窗将删除已选择的范围，确认关闭？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.dialogRange = false;
                })
                .catch(() => { });
        },
        // 过滤方法
        filterMethod(query, item) {
            if (query != '') {
                if (/^[a-zA-Z]*$/.test(query)) {
                    return item.pinyin.indexOf(query) > -1;
                }
                else if (/^[\u4e00-\u9fa5]*$/.test(query)) {
                    return item.label.indexOf(query) > -1;
                }
            }
            return item.pinyin.indexOf(query) > -1;
        },
        // 打开选择范围
        openRange(title, type) {
            this.rangeValue = [];
            this.transferData = [];
            this.rangeTitle = title;
            if (type == "manrange") {
                this.rangeNum = 1;
                if (this.sendDataInfo.manrange.length > 0) {
                    this.rangeValue = this.sendDataInfo.manrange.map(Number);
                }
                this.manrangeList.forEach((item) => {
                    this.transferData.push({
                        label: item.scopeName,
                        key: item.discId,
                        pinyin: item.scopeCode,
                    });
                });
            }
            this.dialogRange = true;
        },
        // 选择范围确定
        confirmRange() {
            if (this.rangeNum == 1) {
                this.sendDataInfo.manrange = this.rangeValue; //经营范围
                var value1 = [];
                this.sendDataInfo.manrange.forEach(val => {
                    if (this.manrangeList) {
                        if (this.manrangeList.filter(item => val == item.discId).length > 0) {
                            value1.push(this.manrangeList.filter(item => val == item.discId)[0].scopeName);
                        }

                    }
                })

                this.sendDataInfo.manrangeName = value1.toString();
            }
            this.dialogRange = false;
        },
        //-----------------------
        //删除随货通行
        delRemove(key, type) {
            this.sendDataInfo[type].splice(key, 1)
        },
        //上传随货同行 2 上传质检 1
        async fileUpload(files, length, index, e, type) {
            if (length - 1 >= index) {
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                if (response.status == 200) {
                    this.sendDataInfo[type].push(response.result[0])
                    this.fileUpload(files, length, index + 1, e, type)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        // 检索Id, 索引(表格中), 标识ppamId
        openSearch(sId, setField, type, index) {
            this.seId = sId;
            this.setField = setField
            this.seType = type;
            this.seIndex = index
            this.parentSearchData = this.sendDataInfo
            this.DialogVisible = true;
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        changeInputModel(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            if (this.setField != null && this.setField != '' && this.setField != undefined) {
                let arr = this.setField.split(',')
                arr.forEach(item => {
                    this.sendDataInfo[item] = val[item]
                })
            } else {
                this.sendDataInfo[this.seType] = val[this.seType]
            }
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        // 确认新增
        async sendDataAction(formName) {
            let flag = false;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
            if (flag) return false;
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (sendData.manrange) {
                sendData.manrange = sendData.manrange.join()
            }
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.basemanufactureradd(sendData);
            } else {
                var responseData = await this.$http.basemanufacturerupdate(sendData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //取消新增
        initActionBox(formName) {
            this.$confirm("确定取消吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.init();
                    this.$emit("drawerCancel", 0);
                    this.$refs[formName].resetFields();
                })
                .catch(() => { });
        },

        async isShowData(name, value) {
            this.sendDataInfo[name] = value;
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == "keydown") {
                if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    this.selectedDetailsIndex = index + 1;
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                        );
                    });
                    return;
                }
                this.addDetails("sendDataInfo");
                return;
            }
            this.$refs[field][index].focus();
        },
        // 初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.fileList = []
            this.sendDataInfo.businesslicense = []
            this.$set(this.sendDataInfo, "manrangeName", "")
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;

            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                if (this.sendDataInfo.manrange && this.sendDataInfo.manrange != null && this.sendDataInfo.manrange != undefined) {
                    this.sendDataInfo.manrange = this.sendDataInfo.manrange.split(',')
                } else {
                    this.sendDataInfo.manrange = []
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                if (this.sendDataInfo.manrange && this.sendDataInfo.manrange != null && this.sendDataInfo.manrange != undefined) {
                    this.sendDataInfo.manrange = this.sendDataInfo.manrange.split(',')
                } else {
                    this.sendDataInfo.manrange = []
                }

            }

            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 输入框切换焦点
        nextFocus(index, fField) {
            if (index >= this.inputel.length - 1) {
                return;
            }
            if (fField == "keydown") {
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });

            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    // if (key.jurconfigform[index].isShow == 1)
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

                }
            });
            var obj = this.$common.filterMainFields(
                this.formDataList,
                [],
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
            this.sendDataInfo.fileList = []
            this.sendDataInfo.businesslicense = []
            this.$set(this.sendDataInfo, "manrangeName", "")
            this.showTabs = this.tabForm[0].jciName;
        },
        //获取生产/经营范围
        async getQueryScopeByType(type) {
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByType(params);
            if (responseData.status == 200) {
                if (type == 1) {
                    this.manrangeList = responseData.result;
                    if (this.dataActionBox.actionType != 0) {
                        var value1 = [];
                        if (this.sendDataInfo.manrange && this.sendDataInfo.manrange.length) {
                            this.sendDataInfo.manrange.forEach(val => {
                                if (this.manrangeList.length > 0) {
                                    if (this.manrangeList.filter(item => val == item.discId).length > 0) {
                                        value1.push(this.manrangeList.filter(item => val == item.discId)[0].scopeName)
                                    }

                                }
                            })
                        }
                        this.sendDataInfo.manrangeName = value1.toString();
                    }
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
            this.getQueryScopeByType(1);
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.el-drawer {
    outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}


#manrange {
    width: 100%;
    display: flex;
    margin-bottom: 10px;
}

::v-deep #manrange .el-form-item__content {
    width: 100% !important;
}

::v-deep #cmManrange .el-textarea__inner {
    width: 73.2% !important;
    margin-right: 20px;
    font-size: 12px;
}

.cmContent {
    width: 90%;
}

.cmButton {
    margin-bottom: 6px;
}

/* 上传图片 */
.upload {
    width: 200px;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.upload li {
    position: relative;
    width: 42px;
    height: 42px;
    margin-right: 5px;
    margin-bottom: 5px;
    border: 1px solid #dedede;
}

.upload .active_li {
    border: none;
}

.image_label {
    display: block;
    width: 42px;
    height: 42px;
}

.upload li:last-child {
    border: none;
}

.upload li:last-child .image_label {
    border: 1px dashed #838383;
}

.upload li:last-child .image_label:hover {
    border: 1px dashed #409eff;
    cursor: pointer;
}

.upload li:last-child:hover .icon {
    color: #409eff;
}

.upload li .icon {
    color: #838383;
    font-size: 20px;
    margin: 10px 0 0 10px;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.upload li:hover .del {
    display: inline-block;
}

::v-deep .el-image__error {
    font-size: 7px;
}

::v-deep .cus-image {
    width: 40px !important;
    height: 40px !important;
}

::v-deep .cus-image img {
    width: 40px !important;
    height: 40px !important;
}
</style>